import { useTranslation } from '@thoughtspot/i18n';
import React, { useEffect, useState } from 'react';
import { useGetStatus } from "../../../services/sidebar/sidebar-service";
import { GenericError } from '../../generic-error/generic-error.container';
import { Header, WithQueryHandler } from '../common';
import { LearnMore, Mode } from '../common/constants';
import { getOrgViewMode } from '../common/utils';
import { TranslationsKeys } from './constants';
import { RevSshComponent } from './rev-ssh/rev-ssh.container';
import styles from './security.module.scss';
import { SslComponent } from './ssl/ssl.container';
const pageName = 'security';
export const SecurityContainer = ({ onSuccess, onError, showLoader, hideLoader, currentOrgId, }) => {
    const { t } = useTranslation();
    const [mode, setMode] = useState(Mode.VIEW);
    const [formType, setFormType] = useState('');
    const [showSsl, setShowSsl] = useState(false);
    const [showRevSsh, setShowRevSsh] = useState(false);
    const { data, loading, error } = useGetStatus(getOrgViewMode(currentOrgId));
    useEffect(() => {
        showLoader();
    }, []);
    useEffect(() => {
        setShowSsl(data?.Data.status.system.security.ssl);
        setShowRevSsh(data?.Data.status.system.security.rev_ssh);
    }, [data]);
    if (error) {
        return React.createElement(GenericError, null);
    }
    if (loading || !data) {
        showLoader();
    }
    return (React.createElement(React.Fragment, null,
        mode === Mode.VIEW && (React.createElement("div", { className: styles.securityContainer },
            React.createElement(Header, { title: t(TranslationsKeys.TITLE), titleSize: "large", learnMoreKey: LearnMore.SECURITY, mode: mode }))),
        showSsl && (React.createElement(SslComponent, { pageName: pageName, mode: mode, setMode: setMode, formType: formType, setFormType: setFormType, showLoader: showLoader, hideLoader: hideLoader, onSuccess: onSuccess, onError: onError })),
        showRevSsh && (React.createElement(RevSshComponent, { pageName: pageName, mode: mode, setMode: setMode, formType: formType, setFormType: setFormType, showLoader: showLoader, hideLoader: hideLoader, onSuccess: onSuccess, onError: onError }))));
};
export const Security = (props) => (React.createElement(WithQueryHandler, null,
    React.createElement(SecurityContainer, { ...props })));
//# sourceMappingURL=security.container.js.map